import { getAvatar, getPublicAssetUrl } from "./Utils";

export const INVOICE_FALLBACK_LOGO_ASSET = "assets/img/logo.jpeg";

let fallbackLogoDataUrlPromise = null;

export const getInvoiceFallbackLogoUrl = () =>
  getPublicAssetUrl(INVOICE_FALLBACK_LOGO_ASSET);

export const normalizeInvoiceLogoValue = (logo) => {
  if (logo === null || logo === undefined) return "";

  const normalized = String(logo).trim();
  if (!normalized) return "";

  const lowered = normalized.toLowerCase();
  if (/^(null|undefined|nan)([./\\-]|$)/.test(lowered)) return "";

  return normalized;
};

export const isInvoiceFallbackLogoValue = (logo) => {
  const normalized = normalizeInvoiceLogoValue(logo);
  if (!normalized) return true;

  const lowered = normalized.replace(/\\/g, "/").toLowerCase();
  return (
    lowered.includes("assets/") ||
    lowered.includes("logo.jpeg") ||
    lowered.includes("logo_vmass")
  );
};

export const getInvoiceLogoInfo = (companyLogo, fallbackLogoDataUrl = "") => {
  const normalizedLogo = normalizeInvoiceLogoValue(companyLogo);
  const fallbackSrc = fallbackLogoDataUrl || getInvoiceFallbackLogoUrl();

  if (isInvoiceFallbackLogoValue(normalizedLogo)) {
    return {
      src: fallbackSrc,
      isFallback: true,
      isCustom: false,
      normalizedLogo: "",
    };
  }

  return {
    src: getAvatar(normalizedLogo),
    isFallback: false,
    isCustom: true,
    normalizedLogo,
  };
};

const isDataImageUrl = (value) =>
  typeof value === "string" && /^data:image\//i.test(value);

const loadImageAsDataUrl = (src) =>
  new Promise((resolve) => {
    if (typeof Image === "undefined" || typeof document === "undefined") {
      resolve("");
      return;
    }

    const img = new Image();
    img.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = img.naturalWidth || img.width;
        canvas.height = img.naturalHeight || img.height;

        if (!canvas.width || !canvas.height) {
          resolve("");
          return;
        }

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const dataUrl = canvas.toDataURL("image/jpeg");
        resolve(isDataImageUrl(dataUrl) ? dataUrl : "");
      } catch (error) {
        resolve("");
      }
    };
    img.onerror = () => resolve("");
    img.src = src;
  });

export const loadInvoiceFallbackLogoDataUrl = () => {
  if (fallbackLogoDataUrlPromise) return fallbackLogoDataUrlPromise;

  fallbackLogoDataUrlPromise = (async () => {
    if (
      typeof window !== "undefined" &&
      window.electronAPI &&
      typeof window.electronAPI.getPublicAssetDataUrl === "function"
    ) {
      try {
        const dataUrl = await window.electronAPI.getPublicAssetDataUrl(
          INVOICE_FALLBACK_LOGO_ASSET,
        );
        if (isDataImageUrl(dataUrl)) return dataUrl;
      } catch (error) {
        // Fall through to the browser-side loader.
      }
    }

    return loadImageAsDataUrl(getInvoiceFallbackLogoUrl());
  })();

  return fallbackLogoDataUrlPromise;
};

export const waitForInvoiceImage = (src, crossOrigin) =>
  new Promise((resolve) => {
    if (!src || isDataImageUrl(src) || typeof Image === "undefined") {
      resolve(true);
      return;
    }

    const img = new Image();
    if (crossOrigin) img.crossOrigin = crossOrigin;
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = src;
  });
